import { HttpClient, HttpResourceRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { endpoints } from '../../../../../environments/endpoints';
import { environment } from '../../../../../environments/environment';
import { ApiService } from '../../../Shared/Services/api.service';
import {
  DemandExportPayload,
  DemandExportResponse,
  DownloadedFile,
} from '../Interfaces/demand-export.interface';
import { requestFileDownload } from '../Shared/report-file-request.util';

@Injectable({ providedIn: 'root' })
export class DemandExportService {
  private readonly _api = inject(ApiService);
  private readonly _http = inject(HttpClient);

  store(payload: DemandExportPayload): Observable<DemandExportResponse> {
    return this._api.run<DemandExportResponse>(
      this._api.post<DemandExportResponse>(endpoints.api.reports.exports.store, {
        body: payload,
        skipLoading: true,
        skipError: true,
      }),
    );
  }

  show(exportId: string): HttpResourceRequest {
    return this._api.get<DemandExportResponse>(endpoints.api.reports.exports.show(exportId), {
      skipLoading: true,
      skipError: true,
    });
  }

  download(exportId: string): Observable<DownloadedFile> {
    const path = endpoints.api.reports.exports.download(exportId);
    return requestFileDownload(this._http, `${environment.api.host}/${path}`);
  }
}
